import React, { StrictMode } from "react";
import {
    createBrowserRouter,
    createRoutesFromElements,
    RouterProvider,
    Route,
    Link,
} from "react-router-dom";

import Layout, { loader as layoutLoader } from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import "./assets/css/umphub.scss";

import IndexRoutes from "./routes/Index";
import OpenGamesRoutes from "./routes/OpenGames";
import MyScheduleRoutes from "./routes/MySchedule";
import AdminRoutes from "./routes/Admin";

const App = (): React.ReactElement => {
    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route
                path="/"
                element={<Layout />}
                errorElement={<ErrorBoundary />}
                loader={layoutLoader}
                handle={{ crumb: () => <Link to="/">Home</Link> }}
            >
                {IndexRoutes}
                {OpenGamesRoutes}
                {MyScheduleRoutes}
                {AdminRoutes}
            </Route>,
        ),
    );

    return (
        <StrictMode>
            <RouterProvider router={router} />
        </StrictMode>
    );
};

export default App;
